import { identity } from 'lodash';

export default {
  demoPage: { pageTitle: 'Demo Page for components' },
  userMenuLinks: {
    changePassword: 'تغيير كلمة المرور',
    userGuide: 'دليل المستخدم',
    logOut: 'تسجيل الخروج',
    welcome: 'مرحباً بك',
  },
  common: {
    complaints: 'الشكاوى',
    complaintList: 'قائمة الشكاوى',
    backToOldVersion: 'العودة للإصدار القديم',
    save: 'حفظ',
    saveAndSend: 'حفظ و إرسال',
    saveAndContinuous: 'حفظ و استمرار',
    saveAndContinuousLater: 'حفظ واستكمال لاحقاً',
    cancel: 'إلغاء',
    submit: 'تقديم',
    close: 'إغلاق',
    add: 'إضافة',
    update: 'تعديل',
    clear: 'مسح',
    redirectToExternalService: 'الإنتقال إلي الخدمة',
    redirectExternalServiceUrl: 'رابط الإنتقال إلي الخدمة',
    redirectExternalServiceUrlMsg: 'يمكنك تقديم طلب انهائي لدوائر الاوقاف و المواريث بالأحساء و القطيف من  خلال النقر على الإنتقال إلي الخدمة',
    back: 'رجوع',
    backToHome: 'العودة للصفحة الرئيسية',
    serviceList: 'قائمة الخدمات',
    next: 'التالي',
    previous: 'السابق',
    remove: 'حذف',
    view: 'معاينة',
    show: 'عرض',
    print: 'طباعة',
    the: 'ال',
    or: 'أو',
    all: 'الكل',
    return: 'عودة',
    selectedOptions: count => `(+${count} اختيار)`,
    removeConfirmation: 'تأكيد الحذف',
    removeConfirmationMessage: 'لا يمكن استرجاع البيانات بعد الحذف. هل ترغب بتأكيد الحذف؟',
    dynamicRemoveConfirmationMessage: name =>
      `لا يمكن استرجاع ${name} بعد حذفه. هل ترغب بتأكيد حذف ${name}؟`,
    delete: 'حذف',
    check: 'تحقق',
    search: 'البحث',
    searchResults: 'نتائج البحث',
    tryAgain: 'حاول مرة أخرى',
    saveAndContinue: 'حفظ ومتابعة',
    representativeRole: 'صفة الممثل',
    representativePartyType: 'نوع الممثل',
    representative: 'ممثل',
    other: 'أخرى',
    authentication: 'مصادقة',
    scan: 'مسح المرفق',
    upload: 'اضغط هنا لرفع المرفق',
    loading: 'جاري التحميل',
    noData: 'عفواً، لم يتم العثور على بيانات',
    selectBoxNoData: 'لا يوجد بيانات',
    rowsPerPage: 'الصفوف في كل صفحة',
    yes: 'نعم',
    no: 'لا',
    savedSuccessfully: 'تم الحفظ بنجاح',
    verificationSucceeded: 'تم التحقق بنجاح',
    verificationFailed: 'فشلت عملية التحقق',
    uploadFailed: 'فشل عملية رفع الملف',
    uploadSuccess: 'تم إرفاق الملف بنجاح',
    caseReplySavedSuccessfully: 'تم حفظ الرد على القضية بنجاح',
    failedToSaveReply: 'فشل حفظ الرد على القضية',
    total: 'الإجمالي',
    showLawsuitAction: 'عرض صحيفة الدعوى',
    hijri: 'هجري',
    gregorian: 'ميلادي',
    fromDate: 'من تاريخ',
    toDate: 'إلى تاريخ',
    cancelConfirmation: 'تأكيد الإلغاء',
    cancelConfirmationMessage: 'هل ترغب بتأكيد الإلغاء؟',
    and: 'و',
    warning: 'تنبيه',
    filter: 'تصفية',
    agree: 'موافق',
    confirmCancelRequest: 'هل انت متأكد من إلغاء الطلب؟',
    confirmRequestCancellation: 'تأكيد إلغاء الطلب',
    confirmRequestSubmission: 'تأكيد إرسال الطلب',
    confirmSubmitRequest: 'هل انت متأكد من إرسال الطلب؟',
    confirmSaveRequest: 'تأكيد حفظ الطلب',
    confirmationSaveMessage: 'هل انت متأكد من حفظ الطلب؟',
    clickHere: 'إضغط هنا',
    confirmationSendRequest: 'تأكيد إرسال الطلب',
    continue: 'متابعة',
    inCompleteReasons: 'أسباب عدم الاكتمال',
    noReasonsToDisplay: 'لا يوجد أسباب لعرضها',
    dearApplicant: 'عزيزي المستفيد',
    byClickHere: 'الضغط هنا',
    new: 'جديد',
    submitRequest: 'تقديم الطلب',
    startService: 'استخدام الخدمة',
    abandoned: 'متنازل عنه',
    notFound: 'عفواً البيانات المدخلة غير صحيحة يرجى التحقق من البيانات.',
    underConstruction: 'عفواً الخدمة تحت الإنشاء.',
    newRequest: 'إنشاء طلب',
    attachments: 'المرفقات',
    addAttachment: 'إضافة مرفق',
    attachmentName: 'اسم المرفق',
  },
  attachment: {
    dragHeader: ' اسحب وأفلت الملف هنا أو',
    chooseFileHeader: 'اختر من الملفات',
    dropHeader: 'افلت الملف هنا',
    thisFileUploadedBefore: `لقد تم إضافة هذا الملف مسبقاً`,
    extensionError: 'صيغة الملف غير صحيحة',
    acceptedExtensionMessage: accepted => `الصيغ المقبولة ${accepted}`,
    sizeError: 'حجم الملف يجب ان يكون اصغر من 5 ميجابايت',
  },
  generalSpecializedLocationCourtOptions: {
    conditionFound: 'يوجد شرط بين الطرفين لتحديد مكان إقامة الدعوى',
    PartiesCompanyRelated: 'أحد أطراف الدعوى شركة والنزاع متعلق بفرع الشركة',
    other: 'غير ذلك',
  },
  shared: { shouldAddedToList: listName => `يجب إضافة القيمة الى قائمة ${listName}` },
  mobileVerificationModal: {
    title: 'أدخل رمز التحقق',
    timeout: 'عفوا انتهت مهلة ادخال رمز التحقق',
    wrongCodeMessage: 'رمز التحقق غير صحيح حاول مرة اخرى',
    successMessage: 'تم التحقق بنجاح',
  },
  settingsBox: {
    systemColors: 'ألوان النظام',
    fieldsSize: 'حجم الحقول',
    normalFields: 'عادية',
    bigFields: 'كبيرة',
    systemScheme: 'شكل النظام',
    systemDark: 'مظلم',
    systemLight: 'فاتح',
  },
  dataGrid: {
    showAdvancedSearch: 'اضغط لإظهار خيارات البحث المتقدم',
    hideAdvancedSearch: 'اضغط لإخفاء خيارات البحث المتقدم',
  },
  errorPages: {
    forbidden: { title: 'ليس لديك الصلاحية لرؤية هذه الصفحة' },
    pageNotFound: { title: 'الصفحة غير موجودة' },
  },
  breadcrumbs: {
    home: 'خدمة الشكوى الإلكترونية',
    mainPage: 'الصفحة الرئيسية',
    complaints: 'الشكاوى',
    newComplaints: 'شكوى جديدة',
    profilePage: 'بياناتي',
  },
  gender: {
    male: 'ذكر',
    female: 'أنثى',
  },
  yesNoOption: {
    yes: 'نعم',
    no: 'لا',
  },
  status: {
    active: 'مفعل',
    inActive: 'غير مفعل',
  },
  errors: {
    somethingWentWrong: 'حدث خطأ ما',
    wentWrongWhile: name => `حدث خطأ أثناء جلب ${name}`,
  },
  footer: {
    rights: 'المجلس الأعلى للقضاء',
    contact: 'الرقم الموحد للاتصال بالمجلس 920002729',
  },
  header: {
    welcome: 'مرحبا',
    serviceTitle: 'خدمة الشكاوى الاليكتروينة',
  },
  secondHeader: {
    mainPage: 'الرئيسية',
    profilePage: 'بياناتي',
    helpPage: 'المساعدة',
  },
  complaints: {
    newComplaint: {
      userInfoTab: {
        title: ' بياناتي',
        terms: ' التعهد',
        termsDescription: 'أتعهد بتدوين جميع البيانات بالشكل الصحيح حسب الوثائق الرسمية ، وأقر بأنه لم يسبق لي أن تقدمت بموضوع هذه الشكوى للمجلس الأعلى للقضاء، وأن شكواي ليست صورية أو كيدية وأتحمل كامل المسؤولية إذا ثبت خلاف ذلك.',
        cancelTitle: 'تأكيد إلغاء تقديم الشكوى؟',
        confirmCancelTitle: 'تم إلغاء تقديم الشكوى بنجاح',
        confirmCancelMessage: 'سيتم إعادتك الى الصفحة الرئيسية',
        termsErrorMessage: 'عفواً يرجى الموافقة على التعهد لإستكمال الشكوى',
        verifiedMobileErrorMessage: 'عفوا لابد من التحقق من رقم الجوال',
        successComplaintMessage: number => `تم تقديم الشكوى ${number} بنجاح`,
        successComplaintTitle: 'نجاح تقديم الشكوي',
        notifySMSMessage: (identity, number) => `عزيزي  مقدم الشكوى،صاحب الهوية رقم ${identity}، نود إبلاغك بأنه قد تم تقديم الشكوى رقم ${number} بنجاح`,
      },
      complaintCategoryTab: {
        title: '  نوع الشكوى',
        noCaseSelected: 'يرجى تحديد القضية المعنية',
        complaintCategoryInput: 'يرجى تحديد نوع الشكوى',
        complaintSubCategories: 'التصنيف الفرعي',
        complaintCategories: 'التصنيف الرئيسي',
        subCategoryErrorMessage: 'عفواً يرجى اختيار التصنيف الفرعي',
        executionErrorMessage: 'عفواً يرجي التحقق من طلب التنفيذ ',
        icmsHeaders: {
          caseCode: 'رقم القضية',
          category: 'التصنيف',
          applyType: 'الصفة',
          type: 'النوع',
          court: 'المحكمة',
          circle: 'الدائرة',
          prosecutorName: 'المدعي',
          defendantName: 'المدعي عليه',
          creationDate: 'التاريخ',
        },
        executionHeaders: {
          caseCode: ' رقم الطلب',
          type: 'النوع',
          mainDeed: 'السند الرئيسي',
          subDeed: 'السند الفرعي',
          court: 'المحكمة',
          circle: 'الدائرة',
          prosecutorName: 'طالب التنفيذ',
          defendantName: 'المنفذ ضده',
          creationDate: 'التاريخ',
        },
      },
      complaintDetailsTab: {
        title: 'تفاصيل الشكوى ',
        notValidForm: 'عفواً يرجى ادخال البيانات الاجبارية',
      },
      complaintPreviewTab: { title: ' معاينة الشكوى ' },
    },
    complaintDetails: {
      selectSession: 'حدد الجلسة المعينة',
      selectRequest: 'حدد الطلب المعين',
      selectJudgment: 'حدد الحكم المعين',
      noDataForSessions: 'لا يوجد جلسات بهذة القضية',
      noDataForRequests: 'لا يوجد طلبات بهذة القضية',
      noDataForJudgements: 'لا يوجد أحكام بهذة القضية',
      noDataForCases: 'لا يوجد قضايا',
      closingReason: 'سبب إغلاق الشكوى',
      sessionHeaders: {
        sessionNo: 'رقم الجلسة',
        sessionType: 'نوع الجلسة',
        sessionDate: 'تاريخ الجلسة',
        sessionStatus: 'حالة الجلسة',
        subCircleName: 'اسم الدائرة',
      },
      requestHeaders: {
        requestCode: 'رقم الطلب',
        requestDate: 'تاريخ الطلب',
      },
      judgementHeaders: {
        judgementCode: 'رقم الحكم',
        mantoq: 'منطوق الحكم',
        conclusiveDate: 'تاريخ النطق بالحكم',
        caseCode: 'رقم القضية',
        deliveryDate: 'تاريخ تسليم الحكم',
      },
      complaintUserInfo: {
        title: 'بيانات مقدم الشكوى',
        firstName: 'الاسم الأول',
        fatherName: 'اسم الأب',
        grandfatherName: 'اسم الجد',
        familyName: 'اسم العائلة',
        identityNumber: 'رقم الهوية',
        nationality: 'الجنسية',
        mobileNumber: 'رقم الجوال',
        verifyNumber: 'تحقق',
        editMobileNumber: 'تعديل رقم الجوال',
      },
      caseInfo: {
        searchInCases: 'البحث',
        title: 'بيانات القضية',
        caseCode: 'رقم القضية',
        date: 'التاريخ',
        status: 'الحالة',
        relation: 'الصفة',
        type: 'النوع',
        court: 'المحكمة',
        circle: 'الدائرة',
        prosecutorName: 'المدعي',
        DefendantName: 'المدعى عليه',
      },
      requestLogInfo: {
        title: 'سجل الطلبات',
        addNoteRequest: 'إضافة طلب',
        requestCode: 'رقم الطلب',
        requestorName: 'مقدم الطلب',
        requestDate: 'التاريخ',
        details: 'التفاصيل',
        addRequest: 'إنشاء طلب',
        cancelRequest: 'إلغاء الطلب',
        cancelRequestConfirmationTitle: 'تأكيد إلغاء الطلب؟',
        cancelRequestConfirmationMsg: 'سيتم إلغاء الطلب وجميع المرفقات !',
        cancelRequestSucceed: 'تم إلغاء الطلب بنجاح',
        addRequestSucceed: 'تم إضافة الطلب بنجاح',
        addRequestInstructions: `يمكنك اضافة الملاحظات والملفات التي تدعم شكواك وفقا للضوابط التالية
<br>
1-التفاصيل اجبارية وإرفاق الملف اختياري
<br>
2-حجم الملف لا يزيد عن 5 ميجا بايت`,
        requests: 'الطلبات',
        attachmentFileName: 'المرفق',
        cancelRequestFail: 'تعذر إلغاء الطلب',
        requestNumber: 'رقم الطلب',
      },
      clarificationRequestInfo: {
        completed: 'تم الرد',
        inprogress: 'بانتظار الرد',
      },
      complaintInfo: 'تفاصيل الشكوى',
      clarificationDetails: {
        clarification: 'طلب إيضاح',
        clarificationWithAttachment: 'طلب إضافة مرفق',
        sendRequestDetails: 'التفاصيل المرسله',
        response: 'رد المستفيد',
      },
    },
    complainantType: {
      requestNo: 'رقم الطلب',
      attorneyCode: 'رقم الوكالة',
      deedNo: 'رقم صك الولاية',
      unifiedNo: 'رقم الوطني الموحد',
      generalCode: 'الكود',
    },
    executionRequestInfo: {
      title: 'بيانات طلب التنفيذ',
      requestNo: 'رقم الطلب',
      type: 'النوع',
      requestStatus: 'حالة الطلب',
      creationDate: 'تاريخ الإنشاء',
      documentType: 'السند الرئيسي',
      documentTypeGroup: 'السند الفرعي',
      court: 'المحكمة',
      circle: 'الدائرة',
      plaintiff: 'طالب التنفيذ',
      defendant: 'المنفذ ضده',
    },
    title: 'الحضانة',
    custodyRequest: 'طلب حضانة',
    noRequests: 'لا توجد شكوى مقدمة...',
    createNew: 'شكوى جديدة',
    filterWithRequestNo: 'البحث برقم الطلب',
    headers: {
      code: 'رقم الشكوى',
      caseCode: 'رقم القضية',
      executionCode: 'رقم طلب التنفيذ',
      creationDate: 'التاريخ',
      statusName: 'حالة الشكوى',
    },
    filter: {
      code: 'رقم الشكوى',
      creationDate: 'تاريخ تقديم الشكوي',
      status: 'حاله الشكوى',
    },
  },
  lookups: {
    complaintStatuses: 'حالات الشكاوى',
    complaintCategories: 'انواع الشكاوى',
  },
  profile: {
    title: 'بياناتي',
    firstName: 'الاسم الأول',
    fatherName: 'اسم الأب',
    grandFatherName: 'اسم الجد',
    familtName: 'اسم العائلة',
    nationalId: 'رقم الهوية',
    nationality: 'الجنسية',
    mobileNumber: 'رقم الجوال',
  },
};
